import { type ClassValue, clsx } from 'clsx';
import type { SyntheticEvent } from 'react';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const onImageError = (event: SyntheticEvent<HTMLImageElement, Event>) => {
  const target = event.currentTarget;
  target.style.opacity = '0';
};
